import Column from '@components/Column';
import MessageIcon from '@icons/MessageIcon';
import PenIcon from '@icons/PenIcon';
import PhoneIcon from '@icons/PhoneIcon';
import { useFlow } from '@stackflow/react';
import { openExternalLink } from '@utils/nativeUtils';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import CsItem from './CsItem';
import useInquiryInfo from './hooks/useInquiryInfo';

function CsContents() {
    const { t } = useTranslation('customerService');
    const { push } = useFlow();
    const { inquiryInfo, externalContent, phoneContent } = useInquiryInfo();
    if (inquiryInfo) {
        return (
            <Column fullWidth spacing={8}>
                {inquiryInfo.inAppInquiryEnabled && (
                    <CsItem icon={PenIcon}
                        title={t('menu.inquiry')}
                        content={inquiryInfo.inAppNote}
                        onClick={() => push('InquiryActivity', { type: 'WRITE' })} />
                )}
                {inquiryInfo.phoneEnabled && (
                    <CsItem icon={PhoneIcon}
                        title={t('menu.phone')}
                        content={phoneContent}
                        onClick={() => openExternalLink(`tel:${inquiryInfo?.phoneNumber}`)} />
                )}
                {inquiryInfo.externalInquiryEnabled && (
                    <CsItem icon={MessageIcon}
                        title={t('menu.external')}
                        content={externalContent}
                        onClick={() => openExternalLink(inquiryInfo.externalInquiryUrl!)} />
                )}
            </Column>
        );
    }
    return (<Fragment/>);
}

export default CsContents;
